import Avatar from "./Avatar";

// Ad-soyad ayrıştırması: soyad SON kelime, kalanı ad. Avatar yalnız baş
// harfleri için kullanır — görüntülenen metin her zaman tam addır.
export const splitFullName = (name) => {
    const trimmed = (name || '').trim();
    if (!trimmed) return { firstName: '', lastName: '' };
    const splitted = trimmed.split(/\s+/);
    if (splitted.length === 1) return { firstName: splitted[0], lastName: '' };
    const lastName = splitted.at(-1);
    return { firstName: splitted.slice(0, -1).join(' '), lastName };
};

const PersonCell = ({
    name,
    firstName,
    lastName,
    profilePicture,
    size = 32,
    variant = 'square',
    onClick,
    style,
}) => {
    // Ad parçaları ayrı geldiyse onlar esas; yoksa tam addan türetilir.
    const hasParts = !!(firstName || lastName);
    const displayName = hasParts
        ? `${firstName || ''} ${lastName || ''}`.trim()
        : (name || '').trim();

    if (!displayName) return null;

    const parts = hasParts
        ? { firstName: firstName || '', lastName: lastName || '' }
        : splitFullName(displayName);

    const handleClick = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    };

    return (
        <div
            onClick={handleClick}
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                alignItems: 'center',
                cursor: onClick ? 'pointer' : 'default',
                ...style,
            }}
        >
            <Avatar
                src={profilePicture || undefined}
                firstName={parts.firstName}
                lastName={parts.lastName}
                variant={variant}
                size={size}
            />
            <span style={{ marginLeft: '8px' }}>{displayName}</span>
        </div>
    );
};

export default PersonCell;
